import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function WinRmUsernameField({ winrmUsername, error, centralCredential }) {

    const [disableValue, setDisableValue] = useState(false)

    // useEffect(() => {
    //     validationService.validateUsername(winrmUsername, 'winrmUsername');
    //     return () => validationService.cleanValidation('winrmUsername');
    // }, [winrmUsername])

    useEffect(() => {
        if(centralCredential && centralCredential.id > 0) {
            validationService.cleanValidation('winrmUsername');
            onChange('');
            setDisableValue(true);
            //modalDataService.changeWinRmName(' ')
        }
        else {
            validationService.validateNotEmpty(winrmUsername, 'winrmUsername');
            setDisableValue(false);
            //modalDataService.changeWinRmName("");
        }
        // validationService.validateUsername(sshUsername, 'sshUsername');
        return () => validationService.cleanValidation('winrmUsername');
    }, [winrmUsername, centralCredential])

    const onChange = (value) => modalDataService.changeWinRmName(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="winrm_username-key">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="winrm_username-key"
                    disabled={disableValue}
                    value={winrmUsername}
                    placeholder="admin"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("WinRmUsernameField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        winrmUsername: addDeviceModal.winrmUsername || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.winrmUsername,
    }
}

export default connect(mapStateToProps)(WinRmUsernameField);
